const BASE_URL = `${process.env.REACT_APP_API_PERMITS_BASE_URL}/Assignment`;

const json = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return response.status === 204 ? null : response.json();
  }
  throw response;
};

export const bulkAssign = async (token, payload) => {
  const response = await fetch(`${BASE_URL}/bulk-assign`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return json(response);
};
